import { useState } from "react";
import { CopyIcon } from "lucide-react";

interface CopyToClipboardProps {
	text: string;
}

export default function CopyToClipboardButton({ text }: CopyToClipboardProps) {
	const [copied, setCopied] = useState(false);

	const handleCopy = (e: React.MouseEvent) => {
		e.stopPropagation();
		navigator.clipboard.writeText(text);
		setCopied(true);

		// Hide the pop-up after 2 seconds
		setTimeout(() => {
			setCopied(false);
		}, 2000);
	};

	return (
		<div className="relative inline-block">
			{/* Copy Button */}
			<button className="pr-2 cursor-copy" onClick={handleCopy}>
				<CopyIcon className="w-4 h-4 text-gray-900"></CopyIcon>
			</button>

			{/* Tooltip (Appears for 2 seconds) */}
			{copied && (
				<span className="absolute top-[-30px] left-1/2 transform -translate-x-1/2 bg-gray-800 text-white text-xs px-2 py-1 rounded shadow-lg">
					Copied!
				</span>
			)}
		</div>
	);
}
